import { Role } from './role.entities';

export interface Account {
  id?: number;
  accountId: string;
  activeCards: number;
  apartment: string;
  balance: number;
  city: string;
  country: string;
  countryCode: string;
  currency: string;
  email: string;
  hash: string;
  houseNumber: string;
  login: string;
  name: string;
  phone: string;
  postalCode: string;
  region: string;
  role: Role;
  spending: number;
  status: UserStatus;
  street: string;
  surname: string;
  twoFactorStatus: string;
  hasRestrictedAccess?: boolean;
  orgName?: string;
  orgId?: string;
  statusText?: string; // local frontend property
}

export enum UserStatus {
  Active = 'active',
  Invited = 'invited',
  Blocked = 'blocked',
}
